module.exports = __webpack_public_path__ + "static/sliderplaceholder3-8bd20f8eb111a290177bad759e323fe7.jpg";